<template>
  <div id="app">
    <loader />
     <MainContainer v-if="isLoggedIn"/>
     <Auth v-else/>
     <!-- <NotFound /> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loader from './components/additions/Loader.vue';
import MainContainer from './containers/Main.vue';
import Auth from './containers/Auth.vue';
// import NotFound from './views/NotFound.vue';

export default {
  name: 'App',
  components: {
    // NotFound,
    Loader,
    MainContainer,
    Auth,
  },
  methods: {
    ...mapActions({
      fetchUserInfo: 'user/fetchUserInfo',
      checkScreenWidth: 'checkScreenWidth',
    }),
    handleResizeWindow() {
      this.checkScreenWidth(window.innerWidth);
    },
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
      customerId: 'auth/customerId',
    }),
  },
  mounted() {
    if (this.customerId) {
      this.fetchUserInfo(this.customerId);
    }
    this.checkScreenWidth(window.innerWidth);
    window.addEventListener('resize', this.handleResizeWindow);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResizeWindow);
  },
  watch: {
    isLoggedIn(value) {
      if (!value) { this.$router.push({ name: 'signIn' }); } else {
        // check if has ridirectBack prams
        if (this.$route.query.redirectBack) {
          this.$router.push(this.$route.query.redirectBack);
        } else {
          this.$router.push({ name: 'PersonalWall' });
        }
      }
    },
    async customerId(value) {
      if (value) {
        await this.fetchUserInfo(value);
      }
    },
  },
};
</script>

<style>
@media screen and (max-width: 1024px){
  html::-webkit-scrollbar, body::-webkit-scrollbar {
    display: none;
  }
  body {
    scrollbar-width: none;
  }
}
</style>
<style scoped>
#app {
  overflow: hidden;
  background-color: #ebebeb;

}
a:hover{
  text-decoration: none;
}
</style>
